import AccordionItem from './accordion-item';

export default function init() {
  const roots = document.querySelectorAll('.accordion');
  [...roots].forEach((root) => {
    const items = root.querySelectorAll('.accordion__item');
    [...items].map((item) => new AccordionItem({ rootEl: item }));
  });
}
